import React from "react";
import { useNavigate } from "react-router-dom";

function MainPage() {
    const navigate = useNavigate();
  

    return (
        <>
            <section className="container indent-from-top">
                <div className="has-text-weight-bold is-size-5 is-link is-clickable" onClick={() => { navigate('/statChecker')}}>Stat Checker</div>
            </section>
        </>
    );
}

export default MainPage;